import { ACTION_TYPES } from "../../../Constants";
import _ from "lodash";

const isTokenValid = () => {
  const expiration = localStorage.getItem("tokenExpiration");
  return expiration && Date.now() < parseInt(expiration, 10);
};

const readStoredJSON = (value, fallback = null) => {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

const initialState = {
  isAuthenticated: isTokenValid(),
  token: localStorage.getItem("token") || null,
  menuToggle: false,
  userid:localStorage.getItem("userid") || "",
  userType: localStorage.getItem("userType") || "",
  subCmpny: localStorage.getItem("subcompany") || "",
  lewooPayToken: localStorage.getItem("lewooPayToken") || "",
  lewooPaySession: readStoredJSON(localStorage.getItem("lewooPaySession"), null),
  lewooPayAccessRefresh: 0,
  user: (() => {
    try {
      return JSON.parse(localStorage.getItem("authUser") || "null") || {};
    } catch (error) {
      return {};
    }
  })(),
};

const getAuthToken = (payload) =>
  payload?.accessToken ||
  payload?.token ||
  payload?.tokens?.accessToken ||
  payload?.auth?.accessToken;

const getLewooPayToken = (payload) =>
  payload?.lewooPay?.token ||
  payload?.lewooPay?.accessToken ||
  payload?.lewooPayToken ||
  "";

const getLewooPaySession = (payload) => payload?.lewooPay?.session || payload?.lewooPaySession || null;

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.AUTH: {
      const payload = action?.payload || {};
      const resolvedToken = getAuthToken(payload);
      const user = payload?.user || {};
      const lewooPayToken = getLewooPayToken(payload);
      const lewooPaySession = getLewooPaySession(payload);

      if (!_.isEmpty(resolvedToken)) {
        localStorage.setItem("isAuthenticated", true);
        localStorage.setItem("token", resolvedToken);
        localStorage.setItem("tokenExpiration", Date.now() + 1 * 24 * 60 * 60 * 1000);
        localStorage.setItem("userid", user?.id || payload?.id || "");
        localStorage.setItem("userType", user?.userType || payload?.userType || "");
        localStorage.setItem("authUser", JSON.stringify(user || {}));
        if (!_.isEmpty(lewooPayToken)) {
          localStorage.setItem("lewooPayToken", lewooPayToken);
        } else {
          localStorage.removeItem("lewooPayToken");
        }
        if (lewooPaySession) {
          localStorage.setItem("lewooPaySession", JSON.stringify(lewooPaySession));
        } else {
          localStorage.removeItem("lewooPaySession");
        }
        if (payload?.sub_companyName) {
          localStorage.setItem("subcompany", payload.sub_companyName);
        } else {
          localStorage.removeItem("subcompany");
        }
      }
      const tokenExpiration = parseInt(localStorage.getItem("tokenExpiration"), 10);
      const tokenIsValid = tokenExpiration && Date.now() < tokenExpiration;

      return {
        ...state,
        isAuthenticated: !_.isEmpty(resolvedToken) && tokenIsValid ? true : false,
        token: resolvedToken || localStorage.getItem("token") || null,
        userid: localStorage.getItem("userid") || "",
        userType: localStorage.getItem("userType") || "",
        subCmpny: localStorage.getItem("subcompany") || "",
        lewooPayToken: localStorage.getItem("lewooPayToken") || "",
        lewooPaySession: readStoredJSON(localStorage.getItem("lewooPaySession"), null),
        user: (() => {
          try {
            return JSON.parse(localStorage.getItem("authUser") || "null") || {};
          } catch (error) {
            return {};
          }
        })(),
      };
    }
    case ACTION_TYPES.LEWOO_PAY_UPDATE: {
      const payload = action?.payload || {};
      const lewooPayToken = payload?.lewooPayToken || "";
      const lewooPaySession = payload?.lewooPaySession || null;

      if (!_.isEmpty(lewooPayToken)) {
        localStorage.setItem("lewooPayToken", lewooPayToken);
      } else {
        localStorage.removeItem("lewooPayToken");
      }

      if (lewooPaySession) {
        localStorage.setItem("lewooPaySession", JSON.stringify(lewooPaySession));
      } else {
        localStorage.removeItem("lewooPaySession");
      }

      return {
        ...state,
        lewooPayToken: localStorage.getItem("lewooPayToken") || "",
        lewooPaySession: readStoredJSON(localStorage.getItem("lewooPaySession"), null),
      };
    }
    case ACTION_TYPES.LEWOO_PAY_ACCESS_REFRESH: {
      return {
        ...state,
        lewooPayAccessRefresh: Date.now(),
      };
    }
    case ACTION_TYPES.MENU_TOGGLE: {
      return {
        ...state,
        menuToggle: action.payload,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
